<template>
  <div class="word-reading-panel common-panel" v-if="isReady">
    <div class="ques-area-des" v-if="descriptionText">
      {{ serial ? serial + '. ' : '' }}{{ descriptionText }}
    </div>
    <!-- 得分 -->
    <EvaluateScore
      :show="isShowAnAnalysis && currItem.practiced && currItem.practiced == 1 && !recordStatus"
      :score="currItem.total_score"
    ></EvaluateScore>
    <!-- 显示内容 -->
    <div class="panel-content-text">
      <div
        class="panel-content-options"
        v-if="currItem.config && currItem.config.evaluate_stem_type == 'audio'"
      >
        <ButtonTool
          type="play"
          @click.native="playAudio()"
          v-show="topPlayStatus == 'play'"
        ></ButtonTool>
        <ButtonTool
          type="pause"
          @click.native="pauseAudio"
          v-show="topPlayStatus == 'pause'"
        ></ButtonTool>
      </div>

      <PhoneticText
        v-else
        v-for="(item, index) in currItem.screen_text"
        :key="index"
        :originData="recordStatus ? currItem.deep_text[index].content : item.content"
        :baseStyles="baseStylesMethods(item)"
        :style="{
          alignSelf: positionStyle(item),
          fontWeight: fontWeightStyle(item),
          margin: currItem.question_type == 'ek' ? 'auto' : '0 auto',
        }"
        :ifShowSpace="
          !!(currItem.screen_text[index].style && currItem.screen_text[index].style.indent)
        "
        :showPinyin="currItem.screen_text[index].display != 1"
        :onlyPinyin="currItem.screen_text[index].display == 2"
      ></PhoneticText>
      <p class="panel-content-text-translation">
        <span>{{ currItem | localePartOfSpeech }}</span>
        <span>{{ currItem | localeTranslation }}</span>
      </p>
    </div>
    <!-- 回放 -->
    <div class="panel-content-playgroup">
      <ButtonPlayBack
        :show="currItem.practiced && currItem.practiced == 1 && currItem.record_file"
        @click="playbackAudio($event, currItem.record_file)"
      ></ButtonPlayBack>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mixinSndmsc, mixinCommon } from '@/mixins'
import { buildCnResult } from '@/utils/utils.js'
import { CLIENT } from '@/config'
// import { debounce } from 'debounce'
import PhoneticText from '@/components/ui/phoneticText'
const parser = new DOMParser()

export default {
  name: 'CommonSpeechEvaluating',
  mixins: [mixinSndmsc, mixinCommon],
  components: {
    PhoneticText,
  },
  data() {
    return {
      // 当前选择项
      currItem: {},
      // 录音标志
      recordStatus: false,
      speedVal: 1,
      stopFlag: false,
      // 录音倒计时
      downtime: 0,
      // 提交内容
      postData: {},
      // 提交内容默认参数
      defaultParams: {
        total_score: 0,
        percent_score: 0,
        evaluate_html: '',
        question_id: 0,
        record_duration: 0,
        sound_file: '',
        evaluate_result: '',
      },
      // 是否播放中状态
      playStatus: false,
      // 播放状态
      topPlayStatus: 'play',
    }
  },
  computed: {
    isReady() {
      return !!this.jsonData
    },
    language() {
      let local = localStorage.getItem('language')
      return local
    },
    descriptionText() {
      return this.jsonData.question_description_obj
        ? this.jsonData.question_description_obj[this.language]
          ? this.jsonData.question_description_obj[this.language]
          : this.jsonData.question_description_obj['zh']
        : ''
    },
  },
  watch: {
    isReady: {
      handler(val) {
        if (val) {
          this.currItem = this.jsonData
          this.currItem.practiced = 0
          // 深拷贝记录一份
          this.currItem.deep_text = JSON.parse(JSON.stringify(this.currItem.screen_text))
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 录音回放
    playbackAudio(event, src) {
      if (this.recordStatus) return
      this.playStatus && (this.playStatus = false)
      this.$emit('changeShowButtonStatus', 'play')
      this.$player.setRate(1)
      this.$player.play(src, event)
    },
    // 重置录音状态
    restorePlay() {
      this.recordStatus = false
      this.downtime = 0
      this.$emit('handleButtonLoading', false)
      this.$emit('handleButtonStopRecord', false)
      this.$emit('handlersButtonRecord', true)
      this.$emit('setLoadingText', '')
    },
    // 开始录音
    handleStartRecord() {
      this.pauseAudio()
      this.$emit('setLoadingText', this.$t('evaluate_common_training_readyRcord'))
      this.$emit('handleButtonLoading', true)
      this.$emit('handlersButtonRecord', false)
      this.$emit('changeIsError', true)
      this.recordStatus = true
      if (this.currItem.evaluate.category === 'read_word') {
        this.downtime = 10
      } else if (this.currItem.evaluate.category === 'read_sentence') {
        this.downtime = 60
      } else {
        this.downtime = 120
      }
      this.sndmscIns.record({
        category: this.currItem.evaluate.category,
        text: this.currItem.evaluate.evaluate_text,
        // .match(
        //   /[\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/g
        // )
        // .join('')
        // .split('|')[0],
        // text: '你好，今天天气很好，我们一块出去玩吧! \nni2|hao4|,|jin1|tian1|tian1|qi|hen2|hao3|,|wo3|men|yi2|kuai4|chu1|qu4|wan2|ba|!',
      })
    },
    // 停止录音
    handleStopRecord() {
      if (this.stopFlag) {
        this.$emit('handleButtonStopRecord', false)
        this.$emit('handleButtonLoading', true)
        this.$emit('setLoadingText', this.$t('evaluate_common_training_evaluting'))
        this.countdownText = ''
        this.sndmscIns.stop()
        this.sndmscIns.LOCK_PLAY_AND_REOCRD = false
        this.clearRecordingTimer()
      } else {
        layer.msg(
          this.currItem.evaluate.category == 'read_word'
            ? this.$t('evaluate_common_training_atleast')
            : this.$t('evaluate_common_training_atleast2')
        )
      }
    },
    // 用于跳过
    cancel() {
      this.restorePlay()
      this.cancelRecord()
      this.$emit('setWaveform', false)
    },
    // 执行开始录制回调
    record_begin_callbcak(data) {
      this.stopFlag = false
      this.sndmscIns.LOCK_EVALUTE = true
      this.sndmscIns.LOCK_PLAY_AND_REOCRD = true
      this.$emit('handleButtonLoading', false)
      this.$emit('handleButtonStopRecord', true)
      this.recordingTimeInterval(this.handleStopRecord, this.downtime)
      setTimeout(
        () => {
          this.stopFlag = true
        },
        this.currItem.evaluate.category == 'read_word' ? 1000 : 2000
      )
    },
    //评测回调成功后，上传录音文件
    evalute_callback(data) {
      if (data.data) {
        let screen_texts = ''
        this.currItem.screen_text.forEach((item) => {
          screen_texts += item.content
        })
        const result = buildCnResult({
          category: this.currItem.evaluate.category,
          xml: data.data,
          screen_text: `<span>${screen_texts}</span>`,
        })
        // if (result.is_rejected === "true" && this.currItem.evaluate.category !== "read_word") {
        //   this.$message({
        //     message: this.$t("evaluating_tips_common"),
        //     center: true,
        //     type: "warning",
        //     offset: 30,
        //   });
        //   this.restorePlay();
        //   // return 之前判断是否练过,练过也显示下一题
        //   if (this.currItem.practiced) {
        //     this.$emit("changeIsFinished", false);
        //     this.$emit("changeIsError", false);
        //   }
        //   return;
        // } else if (result.isAdditionalAndback === "true") {
        //   this.$message({
        //     message: this.$t("evaluating_tips_additionalAndBack"),
        //     center: true,
        //     type: "warning",
        //     offset: 30,
        //   });
        // }
        const xmlDoc = parser.parseFromString(result.evaluate_html, 'text/xml')

        // 如果需要分析则回显颜色
        if (this.isShowAnAnalysis) {
          this.currItem.screen_text.forEach((item, index) => {
            Object.assign(item, {
              content: new XMLSerializer().serializeToString(
                xmlDoc.querySelectorAll('span')[index + 1]
              ),
            })
          })
        }
        result.evaluate_html = JSON.stringify(
          this.currItem.screen_text.map((item, index) => {
            return new XMLSerializer().serializeToString(xmlDoc.querySelectorAll('span')[index + 1])
          })
        )

        this.postData = {
          ...this.defaultParams,
          ...result,
        }
        this.postData.question_id = this.currItem.index
        this.postData.record_duration = this.sndmscIns.duration
        this.postData.sound_file = data.mp3Url
        this.postData.evaluate_result = data.xmlUrl

        this.sndmscIns.createSrc().then((url) => {
          this.currItem.record_file = url
        })
        let params = {
          ...this.postData,
          total_score: Math.round(Number(this.postData.total_score)),
          fluency_score: Math.round(Number(this.postData.fluency_score)),
          accuracy_score: Math.round(Number(this.postData.accuracy_score)),
          integrity_score: Math.round(Number(this.postData.integrity_score)),
          scores: Math.round(Number((this.postData.total_score / 100) * this.jsonData.score)),
          client_name: CLIENT,
          guid: this.jsonData.guid,
          questionId: this.jsonData.index,
        }
        // params.homework_id = this.$route.query.homework_id
        params.topic_id = this.$route.query.topic_id
        if (this.isCustom) {
          params.resource_id = this.jsonData.resource_id
          this.$set(this.currItem, 'practiced', 1)
          if (this.isShowAnAnalysis) {
            this.$emit('customInterface', params, () => {
              Object.assign(this.currItem, this.postData)
              this.$forceUpdate()
              this.restorePlay()
              this.$emit('changeIsFinished', false)
              this.$emit('changeIsError', false)
              this.$emit('resultScore', this.postData.total_score)
            })
          } else {
            this.$emit('customInterface', params)
            this.$forceUpdate()
            this.restorePlay()
          }
        } else {
          this.postAnswer(params, () => {
            this.$set(this.currItem, 'practiced', 1)
            Object.assign(this.currItem, this.postData)
            this.$forceUpdate()
            this.restorePlay()
            this.$emit('changeIsFinished', false)
            this.$emit('changeIsError', false)
            this.$emit('resultScore', this.postData.total_score)
          })
        }
      }
    },
    // 评测失败
    snd_error_notity(data) {
      console.log('评测失败====>' + data)
      this.restorePlay()
    },
    // 提交记录成功
    afterPost() {
      this.restorePlay()
    },
    // 原音播放
    playAudio() {
      if (this.recordStatus) {
        return
      }
      this.playStatus = true
      this.$emit('changeShowButtonStatus', 'pause')
      this.topPlayStatus = 'pause'
      this.$player.setRate(this.speedVal)
      let audioUrl =
        this.baseUrl + (this.currItem.evaluate.audio_file1 || this.currItem.listen.audio_file)
      this.$player.play(audioUrl)
      this.$player.onended = () => {
        this.$emit('changeShowButtonStatus', 'play')
        this.topPlayStatus = 'play'
        this.playStatus = false
      }
    },
    // 停止播放原音
    pauseAudio() {
      this.$player.pause()
      this.playStatus = false
      this.$emit('changeShowButtonStatus', 'play')
      this.topPlayStatus = 'play'
    },
    baseStylesMethods(obj) {
      let hzFontSize
      let hzLineHeight = '28px'
      if (!obj.style) {
        hzFontSize = '18px'
        return Object.assign({}, this.baseStyles, { hzFontSize, hzLineHeight })
      }
      if (obj.style.type) {
        switch (obj.style.type) {
          case 'h1':
            hzFontSize = '30px'
            hzLineHeight = '30px'
            break
          case 'h2':
            hzFontSize = '26px'
            hzLineHeight = '60px'
            break
          case 'h3':
            hzFontSize = '12px'
            break
          default:
            hzFontSize = '18px'
        }
      } else {
        hzFontSize = '18px'
      }
      return Object.assign({}, this.baseStyles, { hzFontSize, hzLineHeight })
    },
    positionStyle(obj) {
      let position
      if (!obj.style) {
        if (this.jsonData.question_type === 'im') {
          position = 'flex-start'
        } else {
          position = 'center'
        }
        return position
      }
      switch (obj.style.align) {
        case 'left':
          position = 'flex-start'
          break
        case 'center':
          position = 'center'
          break
        case 'right':
          position = 'flex-end'
          break
        default:
          position = 'center'
      }
      return position
    },
    // 字体粗细
    fontWeightStyle(obj) {
      let weight
      if (!obj.style) {
        return 'normal'
      }
      switch (obj.style.type) {
        case 'h1':
          weight = 'bold'
          break
        case 'h2':
          weight = 'bold'
          break
        case 'h3':
          weight = 'normal'
          break
        default:
          weight = 'normal'
      }
      return weight
    },
    // 选择速度
    speedValueChange(item) {
      this.speedVal = item || 1
    },
  },
}
</script>

<style lang="scss" scoped>
@import './common.scss';
.common-panel {
  position: relative;
}
.ques-area-des {
  position: absolute;
  left: 37px;
  top: 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #b5b5be;
  margin-top: 0px;
}
</style>
